/* eslint-disable no-nested-ternary */
/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import { call, put, takeLatest, all, takeEvery } from "redux-saga/effects";
import * as collectorAction from "./actions";

import {
  FetchCollectors,
  FetchACollector,
  CreateCollector,
  EnableCollector,
  DisableCollector,
  FetchCollectorApiKey,
  RegenerateCollectorApiKey,
  DeleteCollector,
  UpdateCollector,
  FetchACollectorConfigStats,
  UpdateLinkedCollector,
  FetchCollectorPlatforms,
  FetchMediaPlugins,
  CreateCollectorConfiguration,
  FetchCollAdFrameworkList,
  FetchCollectorChangeLog,
} from "./services";
import { VALIDATION_ERROR } from "../../app/Constants/Constants";

// worker saga: makes the api call when watcher saga sees the action
export function* fetchCollectorSaga(action) {
  /* istanbul ignore next */
  try {
    const response = yield call(FetchCollectors, action.payload);
    let collectors;
    /* istanbul ignore if */
    collectors = response?.data?.data ? response?.data?.data : {};
    collectors.list = collectors.results;

    /* istanbul ignore next */
    delete collectors.results;
    /* istanbul ignore next */
    yield put(collectorAction.FetchCollectorsSuccess(collectors));
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(collectorAction.FetchCollectorsFailed(error));
  }
}

export function* fetchJavascriptCollectorSaga(action) {
  /* istanbul ignore next */
  try {
    const response = yield call(FetchCollectors, action.payload);
    let collectors;
    /* istanbul ignore if */
    collectors = response?.data?.data ? response?.data?.data : {};
    collectors.list = collectors.results;

    /* istanbul ignore next */
    delete collectors.results;
    /* istanbul ignore next */
    yield put(collectorAction.FetchJavascriptCollectorsSuccess(collectors));
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(collectorAction.FetchJavascriptCollectorsFailed(error));
  }
}

export function* createCollectorSaga(action) {
  try {
    const response = yield call(CreateCollector, action.payload);
    /* istanbul ignore if */
    if (response.data && response.data.success) {
      yield put(collectorAction.CreateCollectorSuccess(response.data));
    } else {
      yield put(
        collectorAction.CreateCollectorFailed({
          message: response.data.message,
        }),
      );
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(collectorAction.CreateCollectorFailed(error));
  }
}

export function* loadMoreCollectorSaga(action) {
  const { payload } = action;
  try {
    const response = yield call(FetchCollectors, payload);
    // checking environment state
    yield put(
      collectorAction.LoadMoreCollectorSuccess(response?.data?.data?.results),
    );
  } catch (error) {
    yield put(collectorAction.LoadMoreCollectorFailed(error));
  }
}

export function* fetchACollectorSaga(action) {
  try {
    const response = yield call(FetchACollector, action.payload);
    if (response?.data?.data) {
      const collectorData = response.data.data;
      let adframeworkList = [];
      if (collectorData?.pluginSupported) {
        const adframworkResponse = yield call(
          FetchCollAdFrameworkList,
          collectorData.playerId,
        );
        adframeworkList = adframworkResponse?.data?.data;
      }
      yield put(
        collectorAction.FetchACollectorSuccess({
          ...collectorData,
          adframeworkList,
        }),
      );
    } else {
      yield put(
        collectorAction.FetchACollectorFailed({
          message: "Something went wrong. Please try later",
        }),
      );
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    if (error.response && error.response.status === 403) {
      yield put(
        collectorAction.ForbiddenCollector({
          message: error.response.status,
        }),
      );
    } else {
      yield put(collectorAction.FetchACollectorFailed(error));
    }
  }
}
export function* fetchCollectorOfDatapipeSaga(action) {
  try {
    const response = yield call(FetchACollector, action.payload);
    /* istanbul ignore else */
    if (response.data && response.data.data && response.data.data.data) {
      yield put(
        collectorAction.FetchCollectorOfDatapipeSuccess(
          response.data.data.data,
        ),
      );
    } else {
      yield put(
        collectorAction.FetchCollectorOfDatapipeFail({
          message: "Something went wrong. Please try later",
        }),
      );
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(collectorAction.FetchCollectorOfDatapipeFail(error));
  }
}
export function* enableCollectorSaga(action) {
  try {
    const response = yield call(EnableCollector, action.payload);
    /* istanbul ignore if */
    if (response.data.success === true) {
      yield put(collectorAction.EnableCollectorSuccess("success"));
    } else {
      yield put(
        collectorAction.EnableCollectorFailed({
          message: "Something went wrong. Please try later",
        }),
      );
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(collectorAction.EnableCollectorFailed(error));
  }
}
export function* disableCollectorSaga(action) {
  try {
    const response = yield call(DisableCollector, action.payload);
    /* istanbul ignore if */
    if (response.data.success === true) {
      yield put(collectorAction.DisableCollectorSuccess("success"));
    } else {
      yield put(
        collectorAction.DisableCollectorFailed({
          message: "Something went wrong. Please try later",
        }),
      );
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(collectorAction.DisableCollectorFailed(error));
  }
}

export function* fetchCollectorApiKeySaga(action) {
  try {
    const response = yield call(FetchCollectorApiKey, action.payload);
    /* istanbul ignore next */
    if (response.data && response.data.success) {
      yield put(
        collectorAction.FetchCollectorApiKeySuccess(
          response.data && response.data.data && response.data.data.apiKey,
        ),
      );
    } else {
      yield put(
        collectorAction.FetchCollectorApiKeyFailed({
          message: response && response.data && response.data.message,
        }),
      );
    }
  } catch (error) {
    yield put(collectorAction.FetchCollectorApiKeyFailed(error));
  }
}

export function* regenerateCollectorApiKeySaga(action) {
  try {
    const response = yield call(RegenerateCollectorApiKey, action.payload);
    /* istanbul ignore next */
    if (response.data && response.data.success) {
      yield put(
        collectorAction.RegenerateCollectorApiKeySuccess(response.data),
      );
    } else {
      yield put(
        collectorAction.RegenerateCollectorApiKeyFailed({
          message: response && response.data && response.data.message,
        }),
      );
    }
  } catch (error) {
    yield put(collectorAction.RegenerateCollectorApiKeyFailed(error));
  }
}
export function* fetchACollectorDelSaga(action) {
  try {
    const response = yield call(FetchACollector, action.payload);
    /* istanbul ignore else */
    if (response.data && response.data.data && response.data.data.data) {
      yield put(
        collectorAction.FetchACollectorDelSuccess(response.data.data.data),
      );
    } else {
      yield put(
        collectorAction.FetchACollectorDelFailed({
          message: "Something went wrong. Please try later",
        }),
      );
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    if (error.response && error.response.status === 403) {
      yield put(
        collectorAction.ForbiddenCollector({
          message: error.response.status,
        }),
      );
    } else {
      yield put(collectorAction.FetchACollectorDelFailed(error));
    }
  }
}
export function* deleteCollectorSaga(action) {
  try {
    const response = yield call(DeleteCollector, action.payload);
    /* istanbul ignore if */
    if (response.data) {
      yield put(collectorAction.DeleteCollectorSuccess(response));
    } else {
      yield put(collectorAction.DeleteCollectorFailed(response));
    }
  } catch (error) {
    yield put(collectorAction.DeleteCollectorFailed(error));
  }
}

export function* UpdateCollectorSaga(action) {
  try {
    const response = yield call(UpdateCollector, action.payload);
    /* istanbul ignore if */
    if (response.data && response.data.success) {
      yield put(collectorAction.UpdateCollectorSuccess(response));
    } else {
      yield put(
        collectorAction.UpdateCollectorFailed({
          message:
            response?.data?.message === VALIDATION_ERROR
              ? response.data.errors[0]
              : response?.data?.message
              ? response.data.message
              : null,
        }),
      );
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(collectorAction.UpdateCollectorFailed(error));
  }
}

export function* fetchACollectorConfigStatsSaga(action) {
  try {
    const response = yield call(FetchACollectorConfigStats, action.payload);
    /* istanbul ignore if */
    if (response && response.data && response.data.success) {
      yield put(
        collectorAction.FetchACollectorConfigStatsSuccess(response.data),
      );
    } else {
      yield put(
        collectorAction.FetchACollectorConfigStatsFailed(response.data),
      );
    }
  } catch (error) {
    yield put(collectorAction.FetchACollectorConfigStatsFailed(error));
  }
}

export function* UpdateLinkedCollectorSaga(action) {
  try {
    const response = yield call(UpdateLinkedCollector, action.payload);
    /* istanbul ignore if */
    if (response.data && response.data.success) {
      yield put(collectorAction.UpdateLinkedCollectorSuccess(response));
      if (action.payload.projectName) {
        yield put(
          collectorAction.UpdateCollectorList(
            action.payload,
            action.payload.projectName,
          ),
        );
      }
    } else {
      yield put(
        collectorAction.UpdateLinkedCollectorFailed({
          message: response.data.message,
        }),
      );
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(collectorAction.UpdateCollectorFailed(error));
  }
}

export function* fetchPlatformsSaga(action) {
  try {
    const response = yield call(FetchCollectorPlatforms, action?.payload);
    /* istanbul ignore if */
    if (response?.data?.success) {
      yield put(collectorAction.FetchPlatformsSuccess(response?.data));
    } else {
      yield put(collectorAction.FetchPlatformsFailed(response?.data));
    }
  } catch (error) {
    yield put(collectorAction.FetchPlatformsFailed(error));
  }
}

export function* FetchMediaPluginsSaga(action) {
  try {
    const response = yield call(FetchMediaPlugins, action?.payload);
    /* istanbul ignore if */
    if (response?.data?.success) {
      yield put(collectorAction.FetchMediaPluginsSuccess(response?.data));
    } else {
      yield put(collectorAction.FetchMediaPluginsFailed(response?.data));
    }
  } catch (error) {
    yield put(collectorAction.FetchMediaPluginsFailed(error));
  }
}
export function* createCollectorConfigSaga(action) {
  try {
    const response = yield call(CreateCollectorConfiguration, action?.payload);
    /* istanbul ignore if */
    if (response?.data?.success) {
      yield put(
        collectorAction.CreateCollectorConfigurationSuccess(response?.data),
      );
    } else {
      yield put(collectorAction.CreateCollectorConfigurationFailed(response));
    }
  } catch (error) {
    yield put(
      collectorAction.CreateCollectorConfigurationFailed(error?.response),
    );
  }
}

export function* loadMoreJavascriptCollectorSaga(action) {
  const { payload } = action;
  try {
    const response = yield call(FetchCollectors, payload);
    // checking environment state
    yield put(
      collectorAction.LoadMoreJavascriptCollectorSuccess(
        response?.data?.data?.results,
      ),
    );
  } catch (error) {
    yield put(collectorAction.LoadMoreJavascriptCollectorFailed(error));
  }
}

export function* fetchCollectorChangeLogSaga(action) {
  try {
    const response = yield call(FetchCollectorChangeLog, action.payload);
    if (response && response.data && response.data.success) {
      yield put(collectorAction.FetchCollectorLogsSuccess(response.data.data));
    } else {
      yield put(collectorAction.FetchCollectorLogsFailed(response.data));
    }
  } catch (error) {
    yield put(collectorAction.FetchCollectorLogsFailed(error));
  }
}

// watcher saga: watches for actions dispatched to the store, starts worker saga
export function* collectorWatcher() {
  yield all([
    takeLatest(collectorAction.types.FETCH_COLLECTORS, fetchCollectorSaga),
    takeEvery(
      collectorAction.types.LOAD_MORE_COLLECTORS,
      loadMoreCollectorSaga,
    ),
    takeLatest(
      collectorAction.types.FETCH_JAVASCRIPT_COLLECTORS,
      fetchJavascriptCollectorSaga,
    ),
    takeLatest(collectorAction.types.CREATE_COLLECTOR, createCollectorSaga),
    takeLatest(collectorAction.types.FETCH_A_COLLECTOR, fetchACollectorSaga),
    takeLatest(collectorAction.types.ENABLE_COLLECTOR, enableCollectorSaga),
    takeLatest(collectorAction.types.DISABLE_COLLECTOR, disableCollectorSaga),
    takeEvery(
      collectorAction.types.FETCH_COLLECTOR_OF_DATAPIPE,
      fetchCollectorOfDatapipeSaga,
    ),
    takeLatest(
      collectorAction.types.FETCH_COLLECTOR_APIKEY,
      fetchCollectorApiKeySaga,
    ),
    takeLatest(
      collectorAction.types.REGENERATE_COLLECTOR_APIKEY,
      regenerateCollectorApiKeySaga,
    ),
    takeLatest(
      collectorAction.types.FETCH_A_COLLECTOR_DEL,
      fetchACollectorDelSaga,
    ),
    takeLatest(collectorAction.types.DELETE_COLLECTOR, deleteCollectorSaga),
    takeEvery(collectorAction.types.UPDATE_COLLECTOR, UpdateCollectorSaga),
    takeLatest(
      collectorAction.types.FETCH_A_COLLECTOR_CONFIG_STATS,
      fetchACollectorConfigStatsSaga,
    ),
    takeEvery(
      collectorAction.types.UPDATE_LINKED_COLLECTOR,
      UpdateLinkedCollectorSaga,
    ),
    takeLatest(collectorAction.types.FETCH_PLATFORMS, fetchPlatformsSaga),
    takeLatest(
      collectorAction.types.FETCH_MEDIA_PLUGINS,
      FetchMediaPluginsSaga,
    ),
    takeLatest(
      collectorAction.types.CREATE_COLLECTOR_CONFIGURATION,
      createCollectorConfigSaga,
    ),
    takeEvery(
      collectorAction.types.LOAD_MORE_JAVASCRIPT_COLLECTORS,
      loadMoreJavascriptCollectorSaga,
    ),
    takeLatest(
      collectorAction.types.FETCH_COLLECTOR_LOGS,
      fetchCollectorChangeLogSaga,
    ),
  ]);
}
